import { lang } from '@umu/ukit-lang';
/**
 * @file
 * @author liudy
 * 获取分享卡
 */

import React, { Component } from 'react';
import { services } from 'common';
const { Toast } = services;
import { ShareType } from '@umu/umu-types';
import { getShareV2 } from '@umu/umu-api';

export interface IParamInput {
    obj_type: ShareType;
    obj_id: string;
    student_id?: string;
    task_id?: number;
    theme_id?: string;
    uid?: string;
    width?: number;
    height?: number;
    circle_id?: string;
    selector?: string;
}


interface IProps {
    objType: ShareType;
    objId: string;
    uid: string;
    width: number;
    themeId?: string;
    studentId?: string;
	circleId?: string;
    onFetched: (picUrl: string) => void;
    oFailed?: () => void;
    selector?: string;
}

interface IStates {
    picUrl: string;
}

export class FetchSharePic extends Component<IProps, IStates> {
    public isImgLoading = false;
    constructor(props: IProps) {
        super(props);
        this.state = {
            picUrl: '',
        };
    }

    public UNSAFE_componentWillMount() {
        if (!this.isImgLoading) {
            this.fetchPic();
        }
    }

    public onFetched = (picUrl: string) => {
        this.setState({
            picUrl,
        });
        this.props.onFetched(picUrl);
        this.isImgLoading = false;
    };

    public oFailed = () => {
        this.isImgLoading = false;
        if (this.props.oFailed) {
            this.props.oFailed();
        }
        Toast.show({
            message: lang('获取图片失败'),
        });
        return;
    };

    public fetchPic = () => {
        const maxFetchCount = 30;
		const timeout = 1000;
        const { objType, objId, uid, width, studentId, themeId, circleId,selector } = this.props;
        const params: IParamInput = {
            obj_type: objType,
            obj_id: objId,
            uid,
            width: width || 720,
            selector: selector || '',
        };
        if (themeId) {
            params.theme_id = themeId;
        }
        if (studentId) {
            params.student_id = studentId;
        }

		if (circleId) {
			params.circle_id = circleId;
		}

        getShareV2(params, {
			poll_max_times: maxFetchCount,
			poll_timeout_ms: timeout,
		}).then((taskResult) => {
			this.onFetched(taskResult.data.pic_url);
        }).catch(() => {
			this.oFailed();
		});
    };

    public render() {
        return <div className="fetch-share-pic">{this.props.children}</div>;
    }
}
